import {Flex, Text, Box, Divider} from '@chakra-ui/react';
import {TimelineItemRecord} from '../../graphql/datocms-generated';
import {Logo} from '../global/logo';

interface TimelineEntryProps {
  title: string;
  description: string;
  date: string;
  accent: string;
}

const TimelineEntry: React.FC<TimelineEntryProps> = ({
  title,
  description,
  date,
  accent,
}) => {
  const dateFormatted = new Date(date).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <Flex height={150} flexDir="column" className="timeline-segment">
      <Flex flexDir="column" alignItems="center">
        <Text textStyle={{base: 'body5_1c', lg: 'body3_1c'}}>
          {dateFormatted}
        </Text>
        <Flex width="100%" alignItems="center">
          <Divider
            colorScheme="buttonGrey"
            className="timeline-start_divider"
          />
          <Box pl={1} pr={2} width="100px">
            <Logo accent={accent} />
          </Box>
          <Divider colorScheme="buttonGrey" className="timeline-end_divider" />
        </Flex>
      </Flex>
      <Flex
        flexDir="column"
        pt={2}
        px={{base: '24px', lg: 4}}
        width={{base: '218px', lg: '320px'}}
        textAlign="center"
      >
        <Text
          mb={2}
          textStyle={{base: 'body3_1c', lg: 'h5_1c'}}
          color="darkGrey"
        >
          {title}
        </Text>
        <Text textStyle={{base: 'body5_1c', lg: 'body3_1c'}}>
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};

interface ReleaseTimelineProps {
  items: Array<Partial<TimelineItemRecord>>;
  heading?: string;
  accent: string;
  background: string;
}

export const ReleaseTimeline: React.FC<ReleaseTimelineProps> = ({
  items,
  heading,
  accent,
  background,
}) => {
  return (
    <Flex
      background={background}
      flexDir="column"
      py="10px"
      id="release-timeline"
    >
      {heading && (
        <Text
          textStyle={{base: 'h5_1c', lg: 'h2_1c'}}
          pt="94px"
          textAlign="center"
        >
          {heading}
        </Text>
      )}
      <Flex
        flexDir="row"
        pt={12}
        px={20}
        pb={100}
        width="100%"
        sx={{
          '.timeline-segment:first-of-type': {
            '.timeline-start_divider': {
              borderColor: 'background',
            },
          },
          '.timeline-segment:last-of-type': {
            '.timeline-end_divider': {
              borderColor: 'background',
            },
          },
        }}
        overflowX={{base: 'scroll', md: 'inherit'}}
        justifyContent={{md: 'center'}}
      >
        {items.length > 0 &&
          items.map(({title, description, date}) => (
            <TimelineEntry
              title={title as string}
              description={description as string}
              date={date as string}
              key={title}
              accent={accent}
            />
          ))}
      </Flex>
    </Flex>
  );
};
